import { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import Logo from "./../assets/transperentNavLogo.png";

export default function Header(props) {
    const device = props.deviceType;

    const [menuOpen, setMenuOpen] = useState(false);
    const [isCompactNav, setIsCompactNav] = useState(false);

    //const navigate = useNavigate();
    //const [navSearch, setNavSearch] = useState("");

    // ✅ AUTO RESPONSIVE NAVBAR
    useEffect(() => {
        const checkWidth = () => {
            setIsCompactNav(window.innerWidth < 1250);
        };

        checkWidth();

        window.addEventListener("resize", checkWidth);

        return () => window.removeEventListener("resize", checkWidth);
    }, []);

    // ✅ SEARCH
    /*const handleNavSearch = () => {
        if (!navSearch.trim()) return;

        navigate(`/products?search=${encodeURIComponent(navSearch)}`);

        setMenuOpen(false);
    };

    /* --------------------- DESKTOP STYLES --------------------- */

    const desktopLinkStyles = {
        marginRight: "auto",
        textTransform: "uppercase",
        fontSize: "25px",
        fontWeight: "bolder",
        alignContent: "center",
        paddingLeft: "10px",
        color: "#f5c518",
        textShadow: "0 0 8px rgba(245,197,24,0.6)",
        textDecoration: "none",
    };

    const desktopNavLinkStyles = {
        textDecoration: "none",
        fontWeight: "600",
        padding: "5px 20px",
        fontSize: "20px",
        display: "inline-block",
        color: "#f5c518",
        textShadow: "0 0 6px rgba(245,197,24,0.5)",
        transition: "0.3s ease",
    };

    const desktopNavLogoStyles = {
        flexBasis: "40%",
        maxWidth: "200px",
        maxHeight: "40px",
        justifyContent: "center",
        flexDirection: "column",
        display: "flex",
        alignItems: "center",
    };

    const desktopHeaderStyles = {
        background: "#333",
        display: "flex",
        alignItems: "center",
        height: "55px",
        paddingBlock: "6px",
        width: "100%",
        color: "#000000",
        borderBottom: "2px solid #f5c518",
        boxShadow: "0 0 18px rgba(245,197,24,0.3)",
        zIndex: 100,
        position: "relative",
    };

    /* --------------------- MOBILE / COMPACT STYLES --------------------- */

    const phoneHeaderStyles = {
        background: "#333",
        borderBottom: "2px solid #f5c518",
        boxShadow: "0 0 16px rgba(245,197,24,0.25)",
        padding: "10px 0",
        position: "relative",
        zIndex: 100,
    };

    const phoneLinkStyles = {
        textTransform: "uppercase",
        fontSize: "28px",
        fontWeight: "bold",
        color: "#f5c518",
        textShadow: "0 0 8px rgba(245,197,24,0.6)",
        margin: "0 auto",
        textDecoration: "none",
    };

    const phoneNavLinkStyles = {
        textDecoration: "none",
        padding: "16px",
        display: "block",
        fontSize: "20px",
        fontWeight: "600",
        color: "#f5c518",
        textShadow: "0 0 6px rgba(245,197,24,0.5)",
        textAlign: "left",
        borderBottom: "1px solid rgba(245,197,24,0.15)",
    };

    const phoneNavLogoStyles = {
        margin: "0 auto",
        maxWidth: "160px",
    };

    const linkStyles =
        device === "desktop" && !isCompactNav
            ? desktopLinkStyles
            : phoneLinkStyles;

    const navLinkStyles =
        device === "desktop" && !isCompactNav
            ? desktopNavLinkStyles
            : phoneNavLinkStyles;

    const imageContainerStyles =
        device === "desktop" && !isCompactNav
            ? desktopNavLogoStyles
            : phoneNavLogoStyles;

    const headerStyles =
        device === "desktop" && !isCompactNav
            ? desktopHeaderStyles
            : phoneHeaderStyles;

    const imageStyles = {
        maxWidth: "100%",
        padding: "10px",
        filter: "drop-shadow(0 0 6px rgba(245,197,24,0.6))",
    };

    const compactMode = device === "phone" || isCompactNav;

    return (
        <>
            <header className="header" style={headerStyles}>

                {/* ✅ HAMBURGER */}
                {compactMode && (
                    <div
                        onClick={() => setMenuOpen(!menuOpen)}
                        style={{
                            fontSize: "34px",
                            padding: "6px 12px",
                            cursor: "pointer",
                            color: "#f5c518",
                            textShadow: "0 0 6px rgba(245,197,24,0.45)",
                            position: "absolute",
                            left: "10px",
                            top: "8px",
                            zIndex: 300,
                        }}
                    >
                        {menuOpen ? "✕" : "☰"}
                    </div>
                )}

                {/* ✅ LOGO */}
                <Link to="/" className="homePageLink" style={linkStyles}>
                    <div style={imageContainerStyles}>
                        <img src={Logo} style={imageStyles} alt="logo" />
                    </div>
                </Link>

                {/* ✅ DESKTOP SEARCH */}
                {/*!compactMode && (
                    <div
                        style={{
                            marginLeft: "20px",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                        }}
                    >
                        <input
                            type="text"
                            placeholder="Search products..."
                            value={navSearch}
                            onChange={(e) => setNavSearch(e.target.value)}
                            onKeyDown={(e) =>
                                e.key === "Enter" && handleNavSearch()
                            }
                            style={{
                                padding: "4px 8px",
                                height: "28px",
                                borderRadius: "6px",
                                border: "1px solid #555",
                                background: "#222",
                                color: "#f5c518",
                                width: "180px",
                                fontSize: "14px",
                                outline: "none",
                            }}
                        />

                        <button
                            onClick={handleNavSearch}
                            style={{
                                height: "28px",
                                padding: "0 10px",
                                background: "#f5c518",
                                color: "#111",
                                fontWeight: "600",
                                border: "none",
                                borderRadius: "6px",
                                cursor: "pointer",
                            }}
                        >
                            Search
                        </button>
                    </div>
                )*/}

                {/* ✅ DESKTOP NAV */}
                {!compactMode && (
                    <nav>
                        <div
                            className="header-navlinks"
                            style={{
                                display: "flex",
                                alignItems: "center",
                                marginLeft: "20px",
                            }}
                        >
                            <NavLink to="products" style={navLinkStyles}>
                                Products
                            </NavLink>

                            <NavLink to="booking" style={navLinkStyles}>
                                Book Appointment
                            </NavLink>

                            {/*<NavLink to="blog" style={navLinkStyles}>
                                Blog
                            </NavLink>*/}

                            <NavLink to="contacts" style={navLinkStyles}>
                                Contacts
                            </NavLink>
                        </div>
                    </nav>
                )}
            </header>

            {/* ✅ OVERLAY */}
            {compactMode && menuOpen && (
                <div
                    onClick={() => setMenuOpen(false)}
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        background: "rgba(0,0,0,0.45)",
                        zIndex: 150,
                    }}
                ></div>
            )}

            {/* ✅ SIDENAV */}
            {compactMode && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: menuOpen ? "0" : "-320px",
                        width: "300px",
                        height: "100vh",
                        background: "#1e1e1e",
                        borderRight: "2px solid #f5c518",
                        boxShadow: "8px 0 30px rgba(0,0,0,0.5)",
                        transition: "0.35s ease",
                        zIndex: 200,
                        paddingTop: "80px",
                        overflowY: "auto",
                    }}
                >
                    {/* ✅ SEARCH */}
                    {/*<div
                        style={{
                            padding: "0 16px 20px",
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                        }}
                    >
                        <input
                            type="text"
                            placeholder="Search products..."
                            value={navSearch}
                            onChange={(e) => setNavSearch(e.target.value)}
                            onKeyDown={(e) =>
                                e.key === "Enter" && handleNavSearch()
                            }
                            style={{
                                padding: "12px",
                                borderRadius: "8px",
                                border: "1px solid #555",
                                background: "#2a2a2a",
                                color: "#f5c518",
                                fontSize: "16px",
                                outline: "none",
                            }}
                        />

                        <button
                            onClick={handleNavSearch}
                            style={{
                                padding: "12px",
                                background: "#f5c518",
                                color: "#111",
                                fontWeight: "700",
                                border: "none",
                                borderRadius: "8px",
                                cursor: "pointer",
                            }}
                        >
                            Search
                        </button>
                    </div>*/}

                    {/* ✅ NAV LINKS */}
                    <NavLink
                        to="products"
                        style={navLinkStyles}
                        onClick={() => setMenuOpen(false)}
                    >
                        Products
                    </NavLink>

                    <NavLink
                        to="booking"
                        style={navLinkStyles}
                        onClick={() => setMenuOpen(false)}
                    >
                        Book Appointment
                    </NavLink>

                    {/*<NavLink
                        to="blog"
                        style={navLinkStyles}
                        onClick={() => setMenuOpen(false)}
                    >
                        Blog
                    </NavLink>*/}

                    <NavLink
                        to="contacts"
                        style={navLinkStyles}
                        onClick={() => setMenuOpen(false)}
                    >
                        Contacts
                    </NavLink>
                </div>
            )}
        </>
    );
}